import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal, ModalBody, ModalHeader } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';
import Tag from '@spotahome/ui-library/src/tenant/components/Tag';
import { DSIcon } from '@spotahome/ui-library/base';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import RnaId from '../RnaId';

import './ListingValuePropositionModal.scss';

const ListingValuePropositionModal = ({
  isOpen,
  onRequestClose,
  chipList = [],
  landlordDescription = '',
  listingDescription = '',
  roomDescription = '',
  rnaIdFeature = null
}) => {
  const chips = chipList
    .filter(tag => !tag.hideInExperiment && tag.icon)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map(tag => (
      <Tag
        key={tag.name}
        label={tag.name}
        renderLeadingIcon={() => <DSIcon name={tag.icon} />}
        isSpaced
        size="big"
        colorSchema="light"
        labelClassName={classNames({
          'listing-chips-container__tag--not-included': !tag.value
        })}
      />
    ));

  return (
    <Modal onRequestClose={onRequestClose} isOpen={isOpen} size="medium">
      <ModalHeader
        showClose
        onRequestClose={onRequestClose}
        label={trans('listing.value.proposition.title')}
        className="listing-value-proposition-modal__header"
      />
      <ModalBody className="listing-value-proposition-modal__body">
        {chips.length > 0 && (
          <div className="listing-value-proposition-modal__chips listing-chips-container">
            {chips}
          </div>
        )}
        {landlordDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('listing.overview.landlord.description.title')}
            </ListingTitle>
            <ListingContent content={landlordDescription} />
          </div>
        )}
        {listingDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('listing.overview.description.title')}
            </ListingTitle>
            <ListingContent content={listingDescription} />
          </div>
        )}
        {roomDescription && (
          <div className="listing-value-proposition-modal__section">
            <ListingTitle role="tertiary">
              {trans('property_show.title.room_description')}
            </ListingTitle>
            <ListingContent content={roomDescription} />
          </div>
        )}
        {rnaIdFeature && rnaIdFeature?.value !== 'no' && (
          <RnaId
            className="listing-value-proposition-modal__section--rna-id-content"
            rnaIdFeature={rnaIdFeature}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

ListingValuePropositionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  chipList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      icon: PropTypes.string,
      value: PropTypes.bool,
      order: PropTypes.number
    })
  ),
  landlordDescription: PropTypes.string,
  listingDescription: PropTypes.string,
  roomDescription: PropTypes.string,
  rnaIdFeature: PropTypes.shape({
    value: PropTypes.string,
    additionalInfo: PropTypes.string
  })
};

export default ListingValuePropositionModal;
